import type {
  Partition,
  RuntimeEnvironment
} from "@common-core/web-component-runtime/runtime";
import {consume, provide} from "@lit/context";
import {Task} from "@lit/task";
import {html, LitElement} from "lit";
import {customElement} from "lit/decorators.js";
import {unsafeStatic} from "lit/static-html.js";

import type {BridgeBarConfig} from "../config/BridgeBarConfig";
import {BridgeBarConfigContext} from "../config/BridgeBarConfigContext";
import {ROOT_TAG} from "../globals";
import {activateRuntime} from "./activateRuntime";
import type {Environment} from "./Environment";
import {RuntimeContext} from "./RuntimeContext";

const tagName = `${ROOT_TAG}-runtime-provider`;
export const RuntimeProvider = unsafeStatic(tagName);

@customElement(tagName)
export class RuntimeProviderElement extends LitElement {
  @consume({context: BridgeBarConfigContext, subscribe: true})
  private _config: BridgeBarConfig | undefined;

  @provide({context: RuntimeContext})
  runtimeEnvironment: RuntimeEnvironment<Environment, unknown>;

  private readonly getRuntimeEnvironment = new Task<
    readonly [string | undefined, Partition | undefined]
  >(this, {
    args: () => [this._config?.deployment, this._config?.partition] as const,
    task: async ([deployment, partition]) => {
      if (!deployment || !partition) {
        return;
      }

      this.runtimeEnvironment = await activateRuntime({
        deployment,
        partition
      });

      this.runtimeEnvironment.environment = {
        ...this.runtimeEnvironment.environment
      };
    }
  });

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [tagName]: RuntimeProviderElement;
  }
}
